import React, { FC } from 'react';
import styled, { css } from 'styled-components';

export type Columns = '2' | '3' | '4' | 'none';

export interface GridProps {
  children: any;
  desktopColumns?: Columns;
  tabletColumns?: Columns;
  as?: any;
}

interface StyledGridProps {
  desktopColumns: Columns;
  tabletColumns: Columns;
}

const StyledGrid = styled.div<StyledGridProps>`
  ${({ theme: { space, media }, tabletColumns, desktopColumns }) => css`
    display: grid;
    gap: ${space.md};

    // Tablet > styles
    ${tabletColumns !== 'none' &&
    css`
      @media (min-width: ${media.md}) {
        grid-template-columns: ${`repeat(${tabletColumns}, 1fr)`};
        gap: ${space.lg};
      }
    `}

    // Desktop > styles
    ${desktopColumns !== 'none' &&
    css`
      @media (min-width: ${media.xl}) {
        grid-template-columns: ${`repeat(${desktopColumns}, 1fr)`};
      }
    `}
  `};
`;

export const Grid: FC<React.PropsWithChildren<GridProps>> = ({
  children,
  desktopColumns = '3',
  tabletColumns = '2',
  as,
  ...rest
}) => (
  <StyledGrid tabletColumns={tabletColumns} desktopColumns={desktopColumns} as={as} {...rest}>
    {children}
  </StyledGrid>
);
